module.exports = __webpack_public_path__ + "static/service-worker-development-cookbook-42d0992cfe31f1966a33c6bb943aaf71.jpg";